<template>
  <teleport to="#modal_backdrop">
    <div @click="$emit('exit-modal')" class="backdrop-popup"></div>
    <div class="download-app-content">
      <button class="close-button" @click="$emit('exit-modal')">
        <v-icon icon="mdi-close" />
      </button>
      <div
        class="main-page-content ma-auto d-flex flex-column justify-center align-center ga-5"
      >
        <h1 class="label-title">{{ $t("DownloadAppPage.contentTitle") }}</h1>
        <p>
          {{ `${getUserName}, ` + $t("DownloadAppPage.contentSubTitle") }}
        </p>
      </div>
      <ButtonContainer
        style="width: 90%"
        mode="downloadApp"
        :loading="loading"
        :textSize="isMobile ? '18px' : '20px'"
        :buttonText="$t('DownloadAppPage.installButton')"
        @click="bottomSheet = true"
      />
    </div>
    <v-bottom-sheet v-model="bottomSheet">
      <v-card
        class="text-center rounded-xl ma-auto mb-5"
        height="270"
        max-width="95%"
      >
        <v-icon
          class="sheet-icon"
          color="#444444"
          icon="mdi-close"
          @click="bottomSheet = !bottomSheet"
        />
        <v-card-text class="mt-3">
          <div
            class="bottomSheet-content d-flex flex-column justify-start ga-2"
          >
            <h1>
              {{
                isIOS
                  ? $t("DownloadAppPage.titleIOSSheet")
                  : isAndroid
                  ? $t("DownloadAppPage.titleAndroidSheet")
                  : $t("DownloadAppPage.titleDesktopSheet")
              }}
            </h1>
            <p>
              {{
                isIOS
                  ? $t("DownloadAppPage.subTitleIOSSheet")
                  : isAndroid
                  ? $t("DownloadAppPage.subTitleAndroidSheet")
                  : $t("DownloadAppPage.subTitleDesktopSheet")
              }}
            </p>
            <ol class="text-right pr-4">
              <li>
                {{
                  isIOS
                    ? $t("DownloadAppPage.sheetInstructIOSOne")
                    : isAndroid
                    ? $t("DownloadAppPage.sheetInstructAndroidOne")
                    : $t("DownloadAppPage.sheetInstructDesktopOne")
                }}
                <v-icon
                  v-if="isIOS || isAndroid"
                  class="instructIcon one"
                  :icon="isIOS ? 'mdi-export-variant' : 'mdi-dots-vertical'"
                />
                <img
                  v-else
                  alt="desktop-icon"
                  src="@/assets/images/desktop-icon.png"
                />
              </li>
              <li>
                {{
                  isIOS || isAndroid
                    ? $t("DownloadAppPage.sheetInstructTwo")
                    : $t("DownloadAppPage.sheetInstructDesktopTwo")
                }}
                <span v-if="isAndroid || isIOS" class="instructIcon two"
                  >{{ $t("DownloadAppPage.sheetInstructTwoDes") }}
                  <v-icon
                    :icon="
                      isIOS
                        ? 'mdi-plus-box-outline'
                        : 'mdi-cellphone-arrow-down-variant'
                    "
                /></span>
                <div v-else>
                  <img
                    class="desktop-pwa-install-picture"
                    alt="desktop-pwa-install-picture"
                    src="@/assets/images/desktop-pwa-install.png"
                  />
                </div>
              </li>
            </ol>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </teleport>
</template>

<script>
import ButtonContainer from "../UI/ButtonContainer.vue";
import { mapGetters } from "vuex";

export default {
  emits: ["exit-modal"],
  components: {
    ButtonContainer,
  },
  data() {
    return {
      bottomSheet: false,
    };
  },
  computed: {
    isIOS() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return (
        /iphone|ipad|ipod/.test(userAgent) ||
        // Detect iOS on iPad with newer iPadOS that shows as desktop
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },
    isAndroid() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /android/.test(userAgent);
    },
    ...mapGetters({
      isMobile: "isMobile",
      getUserName: "AuthModule/getUserName",
    }),
  },
};
</script>

<style lang="scss">
.v-overlay__content.v-bottom-sheet__content {
  box-shadow: unset !important;
}
</style>
<style scoped lang="scss">
.desktop-pwa-install-picture {
  width: 400px;
}
.backdrop-popup {
  background-color: #5a5a5ab9;
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 12;
}
.download-app-content {
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  z-index: 12;
  font-size: $mediumTextSize;
  border-radius: 40px;
  background: #ffffff;
  padding: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 450px;
  max-height: 90vh;
  min-height: 300px;
  height: auto;
  overflow: hidden;
}
h1 {
  color: $blackColor;
  margin-bottom: 0px;
  margin-top: 0px;
}

p {
  font-size: $mediumTextSize;
  color: #7c7c7c;
}

.main-page-content {
  width: 100%;
  height: 100%;
  h1 {
    font-size: $h1TextTitleSize;
  }
  p {
    width: 80%;
    text-align: center;
    font-size: $mediumTextSize;
    color: #7c7c7c;
  }

  @media (max-width: 601px) {
    h1 {
      font-size: 30px;
    }
  }
}

.bottomSheet-content {
  h1 {
    font-size: $h1TextTitleSize;
    text-align: right;
  }
  p {
    text-align: right;
    width: 100%;
  }
  @media (max-width: 601px) {
    h1 {
      font-size: 30px;
    }
  }
  ol {
    font-size: $mediumTextSize;
    color: $blackColor;
    li {
      margin-bottom: 10px;
    }
  }
}

.instructIcon {
  background: $iconBackgroundColor;
  color: $blackColor;
  margin-right: 10px;
}

.instructIcon.one {
  font-size: 25px;
}
.instructIcon.two {
  font-size: 14px;
  padding: 3px 5px;

  .v-icon {
    margin-right: 10px;
  }
}

.sheet-icon {
  position: absolute;
  top: 15px;
  left: 15px;
}

.close-button {
  position: absolute;
  top: 10px;
  left: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .v-icon {
    color: $blackColor;
    font-size: 24px;
  }
}
</style>
